import { ChangeEvent, useContext, useEffect } from 'react';
import { userDataCtx } from '../../../hooks/applicationData';
import './MedBankProfile.css';
import { checkTrailingSpace } from '../../../js/verificationFunctions';
import { roleMapping, siteOfCareMapping, socRolesRelationship, mbRoleMapping, laCareAreaMapping } from './medbankData';
import ClaimInput from '../ClaimInput';

interface Medbank_Claims {
  role: string;
  site_of_care: string;
  MB_ticket_role: string;
  MB_training_role: string;
  MB_RN_Number: string;
  MB_care_setting: string;
}

const defaultClaimValues = {
  userProvisionStatus: '',
  role: '',
  site_of_care: '',
  MB_ticket_role: '',
  MB_training_role: '',
  MB_RN_Number: '',
  MB_care_setting: ''
};

const ticket_role_options = [
  {name: "No", className:"", value:"User"},
  {name: "Yes", className:"", value:"Admin"}
];

const training_role_options = [
  {name: "No", className:"", value:"User"},
  {name: "Yes", className:"", value:"Admin"}
];

const siteOfCareSelectOptions = () => {
  let siteOfCareOptions : Array<JSX.Element> = [];
  siteOfCareMapping.forEach((value, key) => {
    siteOfCareOptions.push(<option className={value.translationGuid} value={key}>
    {value.defaultDisplayVal}
  </option>)
  })

  return siteOfCareOptions;
}

const RenderRoleDDL = (pSiteOfCare: string, role: string, setRole: (e: ChangeEvent<HTMLSelectElement>) => void, resetRole: () => void) => {
  let roleRelationship = socRolesRelationship.get(pSiteOfCare);
  if(roleRelationship) {
  
    let roles = roleRelationship.map(value => {
      return (
        <option className={value.translationGuid} value={value.value}>
          {value.defaultDisplayVal}
        </option>
      )
    }) ?? [];

    if(roles.length === 0){
      return <select></select>
    }
    if(role !== "" && !roleRelationship.some((val: {translationGuid: string, value: string, defaultDisplayVal: string}) => val.value === role))
    {
      resetRole();
    }
      return (
        <select value={role} id="MB_role" onChange={setRole}>
              <option className="3a131f9f-b20e-4f2b-82c6-088eb9e9e344" value="">
                Select Role
              </option>
              {roles}
        </select>
      )
    }

  return (
    <select>
    </select>
  )
};
function ValidateMedbankClaims(data: any): [boolean, Map<string, boolean>] {
  let validationFlags = new Map<string, boolean>([
    ['roleNeededError', false],
    ['siteOfCareNeededError', false],
    ['ticketRoleNeededError', false],
    ['trainingRoleNeededError', false]
  ]);

  //@ts-ignore
  const claims: Medbank_Claims = data;

  const stringNotEmpty = (str: string) =>
    str !== undefined && str !== null && str !== '';

  //let validRole = stringNotEmpty(claims.role);
  //if (!validRole) validationFlags.set('roleNeededError', true);
  let validSiteOfCare = stringNotEmpty(claims.site_of_care);
  if (!validSiteOfCare) validationFlags.set('siteOfCareNeededError', true);
  let validTicketRole = stringNotEmpty(claims.MB_ticket_role);
  if (!validTicketRole) validationFlags.set('ticketRoleNeededError', true);
  let validTrainingRole = stringNotEmpty(claims.MB_training_role);
  if (!validTrainingRole) validationFlags.set('trainingRoleNeededError', true);
  //return [validRole && validSiteOfCare, validationFlags];

  let isValidated = validSiteOfCare && validTicketRole && validTrainingRole;
  if (isValidated) {
    //auto calculate the rest of the claims
    let calcMbRole = '';
    let mbRole = mbRoleMapping.find((val) => val.soc.includes(claims.site_of_care) && val.ticketRole === claims.MB_ticket_role);
    if (mbRole) {
      claims.role = mbRole.value;
      calcMbRole = mbRole.value;
    }

    let laCareArea = laCareAreaMapping.find((val) => val.soc.includes(claims.site_of_care) && val.role.includes(calcMbRole));
    if (laCareArea) {
      claims.MB_care_setting = laCareArea.value;
    }
  }

  return [isValidated, validationFlags];
};

//TODO Add translations
function EditMedBankClaims(props: any) {
  const { data, setData: setClaim, validationFlags } = useContext(userDataCtx);
  //@ts-ignore
  const claims: Medbank_Claims = data;
  
  const getClaim = (name: string) => {
    const stateClaim = claims[name as keyof Medbank_Claims];
    if (stateClaim) return stateClaim;
    //@ts-ignore
    return defaultClaimValues[name];
  };

  const setRole = (e: ChangeEvent<HTMLSelectElement>) => {
    setClaim('role', e.target.value);
  };

  const resetRole = () => setClaim('role', "")

  const setSiteOfCare = (e: ChangeEvent<HTMLSelectElement>) => {
    setClaim('site_of_care', e.target.value);
  };

  useEffect(() => {
    if (claims.MB_ticket_role !== undefined && claims.MB_ticket_role === 'Admin') {
      setClaim('MB_training_role', 'Admin');
      $('#MB_training_role_select option[value="User"]').hide();
    } else {
      $('#MB_training_role_select option[value="User"]').show();
    }
  }, [claims.MB_ticket_role]);

  const setRNNumber = (number: string) => {
    setClaim("MB_RN_Number", number);
  }

  return <>
    <div className="row" style={{alignItems: 'flex-end' }}>            
      <div className="col-sm-6">
				<label className="71d263ed-44ef-4168-bb52-50170fc9f532 MedBankLabel">
					{' '}
					Site of Care{' '}
        </label>
        <p
					id="needSOC"
					className={
					  validationFlags.get('siteOfCareNeededError')
						? 'error 90e4e1c1-c7aa-4ec4-b430-216dc3b2732d'
						: 'hide 90e4e1c1-c7aa-4ec4-b430-216dc3b2732d'
					}
				  >
					Please select Site of care
        </p>

        <label className="MedBankLabel">
          <select
            value={getClaim('site_of_care')}
            onChange={setSiteOfCare}
            id="ddlSoC"
          >
            <option value="" className="57ec5f0b-7c5d-428e-b04a-4d11325768b9">
              {' '}
              Select Site of Care
              </option>
              {siteOfCareSelectOptions()}
          </select>
        </label>
      </div>
      <div className="col-sm-6">
				{validationFlags.has("ticketRoleNeededError") && validationFlags.get("ticketRoleNeededError") && <p className="accent-1-text">
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
          &nbsp;<span className="">Please select if you need to open service tickets.</span>
          </p>}
        <label className="b091b23a-9774-48a6-b5d5-c387c5dfa392 MB_Ticket_Role_Select" htmlFor="MB_Ticket_Role_Select">Are you responsible for opening service tickets in your organization?</label>
          <select
            id="MB_Ticket_Role_Select"
            value={getClaim("MB_ticket_role")}
            onChange={e => setClaim("MB_ticket_role", e.target.value)}
            className={validationFlags.has("ticketRoleNeededError") && validationFlags.get("ticketRoleNeededError") ? "error" : ""}>
            <option disabled hidden value="" className="">
                Select
            </option>
            {ticket_role_options.map(
                role => <option 
                        data-testid={role.value}
                        key={role.value}
                        className={role.className}
                        value={role.value}>
                    {role.name}
                </option>
            )}
            </select>
      </div>
    </div>
    <div className="row" data-testid="LearningAcademy" >
      <div className="col-sm-6">
				<label className='7cb7b590-a562-46e2-a07d-f6cd4c0d145f rn_number' htmlFor="rn_number">
          {' '}
          License Number - Optional{' '}
        </label>
        <ClaimInput
            placeholder='License Number'
            className=''
            id='rn_number'
            value={getClaim("MB_RN_Number")}
            onChange={(e) => setRNNumber(e.target.value)}
        />
			</div>
      <div className="col-sm-6">              
        {validationFlags.has("trainingRoleNeededError") && validationFlags.get("trainingRoleNeededError") && <p className="accent-1-text">
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
          &nbsp;<span className="">Please select if you need to manage training.</span>
          </p>}          
        <label htmlFor="MB_training_role_select" className="72718c5b-9924-45b4-95da-dd9de6b1616d MB_training_role_select">Will you manage and assign training for other users in this facility?</label>
        <select
          id="MB_training_role_select"
          value={getClaim("MB_training_role")}
          onChange={e => setClaim("MB_training_role", e.target.value)}
          className={validationFlags.has("trainingRoleNeededError") && validationFlags.get("trainingRoleNeededError") ? "error" : ""}>
          <option disabled hidden value="" className="">
              Select
          </option>
          {training_role_options.map(role => <option
                  key={role.value}
                  className={role.className}
                  value={role.value}>
                  {role.name}
              </option>
          )}
        </select>
      </div>
    </div>
  </>;
}

function ReviewMedBankClaims(props: any) {
  const {data} = useContext(userDataCtx);
  //@ts-ignore
  const claims: Medbank_Claims = data;
  const display_ticket_role = ticket_role_options.find(
      role => role.value === claims.MB_ticket_role
  );
  const display_training_role = training_role_options.find(
      role => role.value === claims.MB_training_role
  );
  const siteOfCare = siteOfCareMapping.get(claims.site_of_care);
  const getClaim = (name: string) => {
    const stateClaim = claims[name as keyof Medbank_Claims];
    if (stateClaim) return stateClaim;
    //@ts-ignore
    return defaultClaimValues[name];
  };

  return<>
      <h2> {ShowMedBankName(props)} </h2>
      <div className="row" style={{alignItems: 'flex-end' }}>
        <div className="col-sm-6">
          <p>
            <span className="4fbaad60-63b6-474b-a210-0935fd62d32d">
              Site Of Care:
            </span>{' '}
            <div className={siteOfCare?.translationGuid ?? ""}>{siteOfCare?.defaultDisplayVal ?? ""}</div>
          </p>
        </div>
        <div className="col-sm-6">
            <p>
                <span> <div className="b091b23a-9774-48a6-b5d5-c387c5dfa392 MB_Ticket_Role_Select">Are you responsible for opening service tickets in your organization?</div>:</span> 
                <div className={display_ticket_role?.className}>
                    {getClaim("MB_ticket_role")}
                </div>
            </p>
        </div>
        
      </div>
      <div className='row'>
        <div className="col-sm-6">
            <p>
                <span> <div className="7cb7b590-a562-46e2-a07d-f6cd4c0d145f rn_number">License Number</div>: </span><div>{claims.MB_RN_Number}</div>
            </p>
        </div>
        <div className="col-sm-6">
            <p>
                <span> <div className="72718c5b-9924-45b4-95da-dd9de6b1616d MB_training_role_select">Will you manage and assign training for other users in this facility?</div>:</span> 
                <div className={display_training_role?.className}>
                    {getClaim("MB_training_role")}
                </div>
            </p>
        </div>
      </div>
  </>;
}

function ShowMedBankName(props: any) {
  return (
    <span className="88247b1e-4159-44db-9898-07252a46d05c">
      Care Setting Information
    </span>
  );
}

export { EditMedBankClaims, ReviewMedBankClaims, ShowMedBankName, ValidateMedbankClaims };